import { render } from "./DetailEvalOfPatient.vue?vue&type=template&id=39d8ca88&scoped=true&ts=true"
import script from "./DetailEvalOfPatient.vue?vue&type=script&lang=ts"
export * from "./DetailEvalOfPatient.vue?vue&type=script&lang=ts"

import "./DetailEvalOfPatient.vue?vue&type=style&index=0&id=39d8ca88&lang=scss&scoped=true"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/DanhGia_FE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39d8ca88"]])

export default __exports__